import axios from 'axios'
import { api_lp, api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'
import moment from 'moment'

const vaStore = {
  namespaced: true,
  state: () => ({
    total_vendor_active: 0,
    total_vendor_jasa_inti: 0,
    total_vendor_non_inti: 0,
    total_vendor_national: 0,
    total_vendor_inter: 0,

    vendor_per_region: [],

    vendor_per_region_level: 1,
    total_spend_vendor: [],
    total_spend_vendor_level: 1,
    total_vendor_kplh: [],
    total_vendor_k3l: [],
    spend_category_number: [],
    spend_category_number_level: 1,
    department_in_charge: [],
    department_in_charge_level: 1,

    date_range: 0,
    start: '',
    end: '',
    bisnis_unit: '',
    company_code: '',
    region: '',
    kbli: '',
    afiliasi: '',
    sio: '',

    header_loading: false,
    vendor_per_region_loading: false,
    total_spend_vendor_loading: false,
    total_vendor_kplh_loading: false,
    total_vendor_k3l_loading: false,
    spend_category_number_loading: false,
    department_in_charge_loading: false,
  }),
  mutations: {
    UPDATE_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    DEFAULT_HEADER(state, payload) {
      state.total_vendor_active = 0
      state.total_vendor_jasa_inti = 0
      state.total_vendor_non_inti = 0
      state.total_vendor_national = 0
      state.total_vendor_inter = 0
    },
    UPDATE_HEADER(state, payload) {
      state.total_vendor_active = payload.total_vendor_active
      state.total_vendor_jasa_inti = payload.total_vendor_jasa_inti
      state.total_vendor_non_inti = payload.total_vendor_non_inti
      state.total_vendor_national = payload.total_vendor_national
      state.total_vendor_inter = payload.total_vendor_inter
    },
  },
  actions: {
    getHeader: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, region, kbli, afiliasi, sio } = state
      await commit('UPDATE_DATA', { name: 'header_loading', value: true })
      await commit('DEFAULT_HEADER')

      let url = `${api}/api/v1/dashboard-va/header?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`
      if (region) url += `&provinsi_id=${region}`
      if (kbli) url += `&kbli=${kbli}`
      if (afiliasi) url += `&afiliasi=${afiliasi}`
      if (sio) url += `&sio=${sio}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_HEADER', data.data)
          await commit('UPDATE_DATA', { name: 'header_loading', value: false })
        }
      } catch (error) {
        await commit('DEFAULT_HEADER')
        await commit('UPDATE_DATA', { name: 'header_loading', value: false })
      }
    },

    getVendorPerRegion: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, region, kbli, afiliasi, sio } = state
      await commit('UPDATE_DATA', {
        name: 'vendor_per_region_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'vendor_per_region',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/region?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (region) url += `&provinsi_id=${region}`
      if (kbli) url += `&kbli=${kbli}`
      if (afiliasi) url += `&afiliasi=${afiliasi}`
      if (sio) url += `&sio=${sio}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region_level',
            value: 1,
          })
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region_loading',
          value: false,
        })
      }
    },
    getDetailVendorPerRegion: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, region, kbli, afiliasi, sio } = state
      await commit('UPDATE_DATA', {
        name: 'vendor_per_region_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'vendor_per_region',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/region/${payload.type}/${payload.id}?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (region) url += `&provinsi_id=${region}`
      if (kbli) url += `&kbli=${kbli}`
      if (afiliasi) url += `&afiliasi=${afiliasi}`
      if (sio) url += `&sio=${sio}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region_level',
            value: 2,
          })
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region_level',
          value: 2,
        })
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region_loading',
          value: false,
        })
      }
    },
    getVendorPerRegionExportTotal: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'vendor_per_region_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/region-export/total`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region_loading',
          value: false,
        })
      }
    },
    getVendorPerRegionExportDetail: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'vendor_per_region_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/region-export/detail`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'vendor_per_region_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region_loading',
          value: false,
        })
      }
    },

    getTotalVendorKPLH: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, region, kbli, afiliasi, sio } = state
      await commit('UPDATE_DATA', {
        name: 'total_vendor_kplh_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'total_vendor_kplh',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/kplh?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (region) url += `&provinsi_id=${region}`
      if (kbli) url += `&kbli=${kbli}`
      if (afiliasi) url += `&afiliasi=${afiliasi}`
      if (sio) url += `&sio=${sio}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_vendor_kplh',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'total_vendor_kplh_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'total_vendor_kplh',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'total_vendor_kplh_loading',
          value: false,
        })
      }
    },
    getTotalVendorKPLHExport: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, region, kbli, afiliasi, sio } = state

      await commit('UPDATE_DATA', {
        name: 'total_vendor_kplh_loading',
        value: true,
      })

      let where = []

      if (bisnis_unit) where.push(`bisnis_unit=${bisnis_unit}`)
      if (bisnis_unit == 'BCE' && company_code)
        where.push(`kode=${company_code}`)
      if (region) where.push(`provinsi_id=${region}`)
      if (kbli) where.push(`kbli=${kbli}`)
      if (afiliasi) where.push(`afiliasi=${afiliasi}`)
      if (sio) where.push(`sio=${sio}`)

      let temp = ``
      if (where.length > 0) {
        for (let i in where) {
          if (i == 0) {
            temp += `?${where[i]}`
          } else {
            temp += `&${where[i]}`
          }
        }
      }
      where = temp

      let url = `${api}/api/v1/dashboard-va/kplh-export${where}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_vendor_kplh_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'total_vendor_kplh_loading',
          value: false,
        })
      }
    },

    getTotalVendorK3L: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, region, kbli, afiliasi, sio } = state
      await commit('UPDATE_DATA', {
        name: 'total_vendor_k3l_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'total_vendor_k3l',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/k3l?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (region) url += `&provinsi_id=${region}`
      if (kbli) url += `&kbli=${kbli}`
      if (afiliasi) url += `&afiliasi=${afiliasi}`
      if (sio) url += `&sio=${sio}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_vendor_k3l',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'total_vendor_k3l_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'total_vendor_k3l',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'total_vendor_k3l_loading',
          value: false,
        })
      }
    },
    getTotalVendorK3LExport: async ({ commit, state, rootState }, payload) => {
      await commit('UPDATE_DATA', {
        name: 'total_vendor_k3l_loading',
        value: true,
      })
      const url = `${api}/api/v1/dashboard-va/k3l-export`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_vendor_k3l_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'total_vendor_k3l_loading',
          value: false,
        })
      }
    },

    getTotalSpendVendor: async ({ commit, state, rootState }, payload) => {
      const { start, end, bisnis_unit, company_code } = state
      await commit('UPDATE_DATA', {
        name: 'total_spend_vendor_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'total_spend_vendor',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-vendor-region`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor_level',
            value: 1,
          })
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'total_spend_vendor',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'total_spend_vendor_loading',
          value: false,
        })
      }
    },
    getDetailTotalSpendVendor: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state
      await commit('UPDATE_DATA', {
        name: 'total_spend_vendor_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'total_spend_vendor',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-vendor-region/${payload.type}/${payload.id}`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor_level',
            value: 2,
          })
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'total_spend_vendor',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'total_spend_vendor_level',
          value: 2,
        })
        await commit('UPDATE_DATA', {
          name: 'total_spend_vendor_loading',
          value: false,
        })
      }
    },
    getTotalSpendVendorTotal: async ({ commit, state, rootState }, payload) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'total_spend_vendor_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-vendor-region-export/total`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'total_spend_vendor_loading',
          value: false,
        })
      }
    },
    getTotalSpendVendorDetail: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'total_spend_vendor_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-vendor-region-export/detail`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'total_spend_vendor_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'total_spend_vendor_loading',
          value: false,
        })
      }
    },

    getTotalSpendCategoryNumber: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state
      await commit('UPDATE_DATA', {
        name: 'spend_category_number_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'spend_category_number',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-vendor?`
      if (start && end) url += `start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'spend_category_number_level',
            value: 1,
          })
          await commit('UPDATE_DATA', {
            name: 'spend_category_number',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'spend_category_number_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'spend_category_number',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'spend_category_number_loading',
          value: false,
        })
      }
    },
    getDetailTotalSpendCategoryNumber: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state
      await commit('UPDATE_DATA', {
        name: 'spend_category_number_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'spend_category_number',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-vendor/detail/${payload.mat}`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'spend_category_number_level',
            value: 2,
          })
          await commit('UPDATE_DATA', {
            name: 'spend_category_number',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'spend_category_number_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'spend_category_number',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'spend_category_number_level',
          value: 2,
        })
        await commit('UPDATE_DATA', {
          name: 'spend_category_number_loading',
          value: false,
        })
      }
    },
    getTotalSpendCategoryNumberTotal: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'spend_category_number_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-vendor-export/total?`
      if (start && end) url += `start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'spend_category_number_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'spend_category_number_loading',
          value: false,
        })
      }
    },
    getTotalSpendCategoryNumberDetail: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'spend_category_number_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-vendor-export/detail?`
      if (start && end) url += `start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'spend_category_number_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'spend_category_number_loading',
          value: false,
        })
      }
    },

    getTotalDepartmentInCharge: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end } = state
      await commit('UPDATE_DATA', {
        name: 'department_in_charge_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'department_in_charge',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-dept`
      if (start && end) url += `?start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'department_in_charge_level',
            value: 1,
          })
          await commit('UPDATE_DATA', {
            name: 'department_in_charge',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'department_in_charge_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'department_in_charge',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'department_in_charge_loading',
          value: false,
        })
      }
    },
    getDetailTotalDepartmentInCharge: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end } = state
      await commit('UPDATE_DATA', {
        name: 'department_in_charge_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'department_in_charge',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-dept/detail/${payload.mat}`
      if (start && end) url += `?start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'department_in_charge_level',
            value: 2,
          })
          await commit('UPDATE_DATA', {
            name: 'department_in_charge',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'department_in_charge_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'department_in_charge',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'department_in_charge_level',
          value: 2,
        })
        await commit('UPDATE_DATA', {
          name: 'department_in_charge_loading',
          value: false,
        })
      }
    },
    getTotalDepartmentInChargeTotal: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'department_in_charge_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-dept-export/total`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'department_in_charge_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'department_in_charge_loading',
          value: false,
        })
      }
    },
    getTotalDepartmentInChargeDetail: async (
      { commit, state, rootState },
      payload
    ) => {
      const { start, end, bisnis_unit, company_code } = state

      await commit('UPDATE_DATA', {
        name: 'department_in_charge_loading',
        value: true,
      })

      let url = `${api}/api/v1/dashboard-va/total-spend-category-dept-export/detail`
      if (start && end) url += `?start=${start}&end=${end}`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'department_in_charge_loading',
            value: false,
          })
          return data.data
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('UPDATE_DATA', {
          name: 'department_in_charge_loading',
          value: false,
        })
      }
    },

    filterDate: async ({ dispatch, commit, state, rootState }, payload) => {
      await dispatch('getTotalSpendVendor')
      await dispatch('getTotalSpendCategoryNumber')
      await dispatch('getTotalDepartmentInCharge')
    },
    allFilter: async ({ dispatch, commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code } = state
      await dispatch('getHeader')
      await dispatch('getVendorPerRegion')
      await dispatch('getTotalVendorKPLH')
      await dispatch('getTotalVendorK3L')

      if (bisnis_unit || company_code) {
        await dispatch('getTotalSpendVendor')
        await dispatch('getTotalSpendCategoryNumber')
        await dispatch('getTotalDepartmentInCharge')
      }
    },
  },
}

export default vaStore
